// Always throws, so the type safety of it's return type doesn't matter.
// Using `any` as the return allows us to use this in expressions.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const assertUnreachable = (reason: string): any => {
    throw new Error(`Code path expected to be unreachable: ${reason}`);
};
